import { Box, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { InspirationChoiceTile } from "web_myplann/Inspiration/Components/InspirationChoiceTile";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	label: string;
	amount: string;
	selected: boolean;
	onClick?: () => void;
};

export const InspirationAnchorTile: FC<Props> = ({
	icon: Icon,
	label,
	amount,
	selected,
	onClick,
}) => {
	const theme = useTheme();

	return (
		<InspirationChoiceTile selected={selected} onClick={onClick}>
			<Box mb={theme.spacingTokens.sm}>
				<IconBox
					bg={selected ? theme.palette.blue[100] : theme.palette.grey[200]}
					size={32}
				>
					<Icon
						size={theme.iconSize.sm}
						color={selected ? theme.palette.blue.main : theme.palette.grey[500]}
					/>
				</IconBox>
			</Box>
			<Typography
				variant="button"
				mb={theme.spacingTokens.xs}
				color={selected ? theme.palette.blue.main : theme.palette.grey[500]}
				textTransform="uppercase"
				textAlign="center"
			>
				{label}
			</Typography>
			<Typography variant="value" tabular>
				{amount}
			</Typography>
		</InspirationChoiceTile>
	);
};
